import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ArticleFeedback.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["S3Image"] */ "/vercel/path0/src/components/S3Image.tsx");
